import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const state = {
    isCollapsed: false,
    platform:'lawyer',
    menuList:[],
    currentUser:{
        username:'',
        UserRefreshToken:'',
        UserToken:''
    },
    tagMenuArr:[],
    tagMenuPathArr:[],
};

const mutations = {
    toggleCollapsed(state,isCollapsed) {
        state.isCollapsed = isCollapsed;
    },
    changeMenu(state,menuList){
        state.menuList = menuList;
    },
    openTagMenu(state,obj){
        state.tagMenuArr = obj.tagMenuArr;
        state.tagMenuPathArr = obj.tagMenuPathArr;
    }
};
const getters = {
	toggleCollapsed(state){
		return state.isCollapsed;
    },
    changeMenu(state){
        return state.menuList;
    },
    openTagMenu(state){
        return state;
    }
}


var vuexStore = new Vuex.Store({
    state,
    mutations,
    getters
});

export default vuexStore;



// WEBPACK FOOTER //
// ./src/store/index.js